export const APPROVE_INVOICE = `${BACKOFFICE_API_URL}/invoices/:invoice_id/approve`
export const EXPORT_INVOICE_LIST = `${BACKOFFICE_API_URL}/export/invoices`
export const FAST_SELL_INVOICES = `${BACKOFFICE_API_URL}/invoices/fastsell`
export const GET_INVOICE_LIST = `${BACKOFFICE_API_URL}/invoices`
export const GET_INVOICE_DETAIL = `${BACKOFFICE_API_URL}/invoices/:invoice_id`
export const CANCEL_INVOICE = `${BACKOFFICE_API_URL}/invoices/:invoice_id/cancel`
export const CREATE_INVOICE = `${BACKOFFICE_API_URL}/invoices`
export const PENDING_INVOICE = `${BACKOFFICE_API_URL}/invoices/:invoice_id/pending`
export const PUBLISH_INVOICE = `${BACKOFFICE_API_URL}/invoices/:invoice_id/publish`
export const SALE_CHECK_INVOICE = `${BACKOFFICE_API_URL}/invoices/:invoice_id/salecheck`
export const SELL_INVOICE = `${BACKOFFICE_API_URL}/invoices/:invoice_id/sell`
export const SETTLE_INVOICE = `${BACKOFFICE_API_URL}/invoices/:invoice_id/settle`
export const REJECT_INVOICE = `${BACKOFFICE_API_URL}/invoices/:invoice_id/reject`
export const WRITEOFF_INVOICE = `${BACKOFFICE_API_URL}/invoices/:invoice_id/writeoff`
export const COMMENT_INVOICE = `${BACKOFFICE_API_URL}/invoices/:invoice_id/comment`
export const GET_INVOICE_PRICING = `${BACKOFFICE_API_URL}/invoices/:invoice_id/pricing`
export const GET_INVOICE_TIMELINE = `${BACKOFFICE_API_URL}/invoices/:invoice_id/timeline`
export const FIND_CASES = `${BACKOFFICE_API_URL}/debt/cases`

export default {
  APPROVE_INVOICE,
  EXPORT_INVOICE_LIST,
  GET_INVOICE_LIST,
  GET_INVOICE_DETAIL,
  FAST_SELL_INVOICES,
  CANCEL_INVOICE,
  PENDING_INVOICE,
  PUBLISH_INVOICE,
  SALE_CHECK_INVOICE,
  SELL_INVOICE,
  SETTLE_INVOICE,
  REJECT_INVOICE,
  WRITEOFF_INVOICE,
  COMMENT_INVOICE,
  GET_INVOICE_PRICING,
  GET_INVOICE_TIMELINE,
  FIND_CASES
}
